import React, { useEffect, useState } from "react";
import {
  Typography,
  Grid,
  CardContent,
  Card,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import Div from "@jumbo/shared/Div";
import {
  getAllowedPermissions,
  getPermissionList,
  updatePermissions,
} from "app/redux/slice/roleSlice";
import { LoadingButton } from "@mui/lab";
import { ROLES } from "app/routes/constant";

const useStyles = makeStyles(() => ({
  moduleRow: {
    padding: "12px 0",
    borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
  },
  moduleName: {
    fontWeight: 600,
    paddingTop: "9px",
    wordBreak: "break-word",
  },
  permissionGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
    columnGap: "16px",
    rowGap: "4px",
  },
  permissionItem: {
    alignItems: "flex-start",
    margin: 0,
    "& .MuiCheckbox-root": {
      padding: "9px",
    },
    "& .MuiFormControlLabel-label": {
      paddingTop: "9px",
      lineHeight: 1.4,
    },
  },
}));

const Permissions = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  var { id } = useParams();
  const [permission, setPermission] = useState([]);
  const [rolesPermission, setRolesPermission] = useState([]);
  const checkedArray = [];

  const handleChange = (event, rec) => {
    if (event.target.checked === true) {
      checkedArray.push(rec?._id);
      setRolesPermission([...rolesPermission, ...checkedArray]);
    }
    if (event.target.checked === false) {
      const filter = rolesPermission.filter(function (data) {
        return data !== rec?._id;
      });
      setRolesPermission(filter);
    }
  };

  const handleSubmit = () => {
    const roleAndPermissions = { roleId: id, permissionId: rolesPermission };
    dispatch(updatePermissions(roleAndPermissions))
      .unwrap()
      .then((response) => {
        if (response?.status === 200) {
          enqueueSnackbar(response.data?.responseMessage, {
            variant: "success",
          });
          navigate(ROLES);
        } else {
          enqueueSnackbar(response?.data?.responseMessage, {
            variant: "error",
          });
        }
      });
  };

  useEffect(() => {
    const GetPermissionList = async () => {
      let response = await dispatch(getPermissionList()).unwrap();
      setPermission(response?.data?.data?.permissionList);
    };
    if (id) {
      dispatch(getAllowedPermissions(id))
        .unwrap()
        .then((response) => {
          if (response?.status === 200) {
            if (response?.data?.data?.rolePermissions) {
              const data = [];
              response?.data?.data?.rolePermissions?.permissionId?.forEach(
                (item) => {
                  const data2 = item?._id;
                  data.push(data2);
                }
              );
              setRolesPermission(data);
            }
          }
        });
    }
    GetPermissionList();
  }, [dispatch, id]);
  return (
    <>
      <Card sx={{ display: "flex" }}>
        <Div sx={{ display: "flex", flexDirection: "column", flex: "1" }}>
          <CardContent>
            <Typography variant={"h2"} mb={2}>
              Permissions
            </Typography>
            {permission?.length
              ? permission?.map((single, index) => (
                  <Grid
                    key={index}
                    container
                    spacing={2}
                    className={classes?.moduleRow}
                  >
                    <Grid item xs={12} md={3} lg={2}>
                      <Typography
                        component="h4"
                        variant="inherit"
                        className={classes?.moduleName}
                      >
                        {single?.module + " :"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={9} lg={10}>
                      <div className={classes?.permissionGrid}>
                        {single?.permissionData?.map((rec) => (
                          <FormControlLabel
                            key={rec?._id}
                            className={classes?.permissionItem}
                            label={rec?.displayName}
                            control={
                              <Checkbox
                                checked={rolesPermission.includes(rec?._id)}
                                onChange={(event) => handleChange(event, rec)}
                                name={rec?.name}
                              />
                            }
                          />
                        ))}
                      </div>
                    </Grid>
                  </Grid>
                ))
              : []}
            <Div sx={{ display: "flex", justifyContent: "flex-end", m: 2 }}>
              <LoadingButton
                variant="outlined"
                color="secondary"
                onClick={() => {
                  navigate(ROLES);
                }}
                size="large"
                sx={{ mb: 2, mr: 2 }}
              >
                Cancel
              </LoadingButton>

              <LoadingButton
                type="submit"
                variant="contained"
                size="large"
                sx={{ mb: 2 }}
                onClick={() => handleSubmit()}
                disabled={rolesPermission?.length === 0}
              >
                Save
              </LoadingButton>
            </Div>
          </CardContent>
        </Div>
      </Card>
    </>
  );
};

export default Permissions;
